export default __webpack_public_path__ + "static/media/hands.eedcc90a.ogg";